import { Component, computed, Signal } from '@angular/core';
import { Card } from 'primeng/card';
import { TauresFooterModule } from '@taures/taures-components/taures-footer';
import { TauresToastModule } from '@taures/taures-components/taures-toast';
import { TauresConfirmDialogComponent } from '@taures/taures-components/taures-confirm-dialog';
import { TauresLayoutCompact } from '@taures/taures-components/taures-layout';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/common/footer/footer.component';
import { WartungComponent } from './components/wartung/wartung.component';
import { DateTime } from 'luxon';
import { toSignal } from '@angular/core/rxjs-interop';
import { timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    Card,
    TauresFooterModule,
    TauresToastModule,
    TauresConfirmDialogComponent,
    TauresLayoutCompact,
    RouterOutlet,
    FooterComponent,
    WartungComponent
  ],
  standalone: true
})
export class AppComponent {
  protected readonly wartungStart: DateTime = DateTime.fromISO('2026-10-20T07:30:00+02:00');
  protected readonly wartungEnde: DateTime = DateTime.fromISO('2026-10-20T10:30:00+02:00');

  private readonly now: Signal<DateTime> = toSignal(timer(0, 5_000).pipe(map((): DateTime => DateTime.now())), { initialValue: DateTime.now() });

  protected readonly inWartung: Signal<boolean> = computed((): boolean => this.now() >= this.wartungStart && this.now() < this.wartungEnde);
  protected readonly wartungAngekuendigt: Signal<boolean> = computed(
    (): boolean => this.now() < this.wartungStart && this.now() >= this.wartungStart.minus({ hours: 6 })
  );
}
